import Compressor from 'compressorjs'
import { getImageDimension } from '$func/image-dimension'
import { blobToFile } from '$func/file'
import hostConf from '$config/frontend'

function promisifiedCompress(file: File, options: Compressor.Options) {
  return new Promise<File>(resolve => {
    // eslint-disable-next-line no-new
    new Compressor(file, {
      ...options,
      success: result => {
        const posterFile = blobToFile(result, file.name)
        // const posterFile = new File([result], file.name, { type: file.type })
        resolve(posterFile)
      },
      error: err => {
        console.log(err)
        resolve(file)
      },
    })
  })
}

export async function getImageThumbnail(file: File, maxDim = 40) {
  const imageDim = await getImageDimension(file)
  return promisifiedCompress(file, {
    maxWidth: Math.min(imageDim.width, maxDim),
    maxHeight: Math.min(imageDim.height, maxDim),
    quality: 0.8,
  })
}

export async function intelligentCompressImage(file: File) {
  const imageDim = await getImageDimension(file)
  const quality = Math.min(imageDim.width, imageDim.height) <= 512 ? 0.8 : 0.6
  return promisifiedCompress(file, { maxHeight: 1920, maxWidth: 1920, quality })
}

export async function intelligentCompressImageForProfile(file: File) {
  return promisifiedCompress(file, {
    maxHeight: 640,
    maxWidth: 640,
    quality: 0.6,
  })
}

export function getCompressedImageLink(url: string | undefined, query: string) {
  if (!url) return ''
  const compressionAddress = hostConf.IMAGE_COMPRESSION_API_ADDRESS
  const s3Host = hostConf.S3_HOST
  return compressionAddress && url && url.includes(s3Host)
    ? `${url.replace(s3Host, compressionAddress)}?${query}`
    : url
}
